export default "__VITE_ASSET__FeR0X_Ki__"